module.exports = __webpack_public_path__ + "img/homebg_1.31d93978.png";